module.exports = __webpack_public_path__ + "static/media/default.28ae3338.png";